export function getPanelFilters(state) {
  return {
    filters: (state) => state.filters,
  };
}
